import { getCurrentUser, updateCurrentUser } from '@/auth/authData';

/**
 * Bug-hunt #87: when backend returns 412 (context selection required),
 * invalidate the user's current context so ForcedContextSelectionModal
 * re-opens on the next render. The modal is gated on
 * `useAuthStore.requiresContextSelection()` which reads
 * `user.canSwitchContext && !user.context?.type`. Clearing the context
 * type flips it back to "needs selection".
 *
 * Audit M7: also null out `organization` and `network` so callers that
 * truthy-check `user.context?.organization` don't see the previous org's
 * data while the user is mid-switch.
 *
 * Exported so it can be unit-tested without booting main.tsx (which
 * mounts the React tree as a side effect).
 */
export function contextRequiredHook(): void {
  if (!getCurrentUser()) return;
  updateCurrentUser({
    context: { type: null, organization: null, network: null, showInternalContacts: false },
  });
}
